'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (text, tag) {
  var regex = RegExp('<' + tag + '>(.*?)</' + tag + '>');

  return text.split(regex).map(function (text, index) {
    return {
      text: text,
      highlight: index % 2 === 1
    };
  }).filter(function (obj) {
    return obj.text !== '';
  });
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/autosuggest-highlight/dist/parseHTML.js
 ** module id = 814
 ** module chunks = 0
 **/